import { WelfareScoreTrend } from '@/components/welfareWidget/welfareWidget.types.ts';
import { Icon } from '@/utils';

import { StyledTrendIcon } from './trendIcon/trendIcon.styles.ts';

type TrendIconProps = {
  trend: WelfareScoreTrend | undefined;
  color: string | undefined;
};

const trendIcons = {
  [WelfareScoreTrend.Up]: Icon.ArrowUp,
  [WelfareScoreTrend.Down]: Icon.ArrowDown,
  [WelfareScoreTrend.Flat]: Icon.Minus,
};

/** An arrow up or down, or a dash when flat, in the given colour in both themes. */
export const TrendIcon = ({ trend, color }: TrendIconProps) => {
  if (!trend) {
    return null;
  }
  const TrendArrow = trendIcons[trend];
  return (
    <StyledTrendIcon $color={color}>
      <TrendArrow />
    </StyledTrendIcon>
  );
};
